import { useState } from "react";
import Cropper from "react-easy-crop";
import { CpsButton } from "corpus";
import type { Point, Area } from "react-easy-crop";
import { getCroppedImg } from "@/lib/crop-image";

interface PictureCropperProps {
  image: string;
  onConfirm: (image: string) => void;
}

export const OnelivPictureCropper = ({
  image,
  onConfirm,
}: PictureCropperProps): JSX.Element => {
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState<Area>({
    x: 0,
    y: 0,
    width: 1,
    height: 1,
  });

  const onClick = async (): Promise<void> => {
    const croppedImageUrl = await getCroppedImg(image, croppedArea);
    onConfirm(croppedImageUrl);
  };

  const onCropComplete = (_: Area, croppedAreaPixels: Area): void => {
    setCroppedArea(croppedAreaPixels);
  };

  return (
    <div>
      <div className="absolute top-0 left-0 right-0 bottom-0">
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          showGrid={false}
          aspect={1}
          cropShape="round"
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </div>
      <div className="absolute bottom-10 h-10 left-1/2 -translate-x-1/2">
        <CpsButton onClick={() => void onClick()}>Confirmar</CpsButton>
      </div>
    </div>
  );
};
